import axios from 'axios'
import {setErrors} from './auth'

export const addContact = (contact, history) => async dispatch => {
    await axios.post('/api/contacts', contact)
    .then(res => history.push('/'))
    .catch(err => dispatch(setErrors(err.message)))
}